import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) navigate("/admin");
    else setError(res.error);
  };

  return (
    <div className="paper-grain min-h-[70vh] flex items-center" data-testid="login-page">
      <div className="max-w-md w-full mx-auto px-6 py-16">
        <p className="overline">Author Access</p>
        <h1 className="font-display text-5xl tracking-tight text-[#1A1A1A] mt-3">
          The Writing Desk
        </h1>
        <p className="mt-3 text-[#5C554E] italic">Sign in to compose new work.</p>

        <form onSubmit={onSubmit} className="mt-10 space-y-6" data-testid="login-form">
          <div>
            <label className="overline block mb-2" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-literary"
              placeholder="you@example.com"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="overline block mb-2" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-literary"
              placeholder="••••••••"
              data-testid="login-password-input"
            />
          </div>
          {error && (
            <p className="text-[#C45543] font-ui text-sm" data-testid="login-error">
              {error}
            </p>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="btn-solid"
            data-testid="login-submit-button"
          >
            {submitting ? "Signing in…" : "Enter"}
          </button>
        </form>
      </div>
    </div>
  );
}
